import {
  AccreditedGender,
  AppointmentType,
  EstablishmentCategory,
  EstablishmentsBaseArgs
} from '@/modules/accredited-establishments/api/types'

export interface FilterObject {
  isDefaultSearch: string
  categories?: EstablishmentCategory[]
  siteAccreditedNetworkId?: string
  specialtyId?: string
  subSpecialtyId?: string
  gender?: AccreditedGender
  appointmentType?: AppointmentType
  providerName?: string
  placeId?: string
  lat?: string
  lon?: string
  radiusInMeters?: string
  range?: [number, number]
}

export const constructFilterObject = (
  args: EstablishmentsBaseArgs & { offset?: number; limit?: number }
): FilterObject => {
  const {
    categoryIds,
    siteAccreditedNetworkId,
    specialtyId,
    subSpecialtyId,
    gender,
    appointmentType,
    providerName,
    radiusInMeters,
    placeId,
    isDefaultSearch,
    lat,
    lon,
    offset,
    limit
  } = args

  const filter: FilterObject = {
    isDefaultSearch: String(isDefaultSearch)
  }

  if (categoryIds?.length) {
    filter.categories = categoryIds
  }

  if (siteAccreditedNetworkId) {
    filter.siteAccreditedNetworkId = siteAccreditedNetworkId
  }

  if (specialtyId) {
    filter.specialtyId = specialtyId
  }

  if (subSpecialtyId) {
    filter.subSpecialtyId = subSpecialtyId
  }

  if (gender) {
    filter.gender = gender
  }

  if (appointmentType) {
    filter.appointmentType = appointmentType
  }

  if (providerName) {
    filter.providerName = providerName
  }

  if (placeId) {
    filter.placeId = placeId
  } else if (lat && lon) {
    filter.lat = lat
    filter.lon = lon
  }

  if (radiusInMeters) {
    filter.radiusInMeters = radiusInMeters
  }

  if (typeof offset === 'number' && typeof limit === 'number') {
    filter.range = [offset, limit]
  }

  return filter
}
